
import './App.css';
import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
// import { HashRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Login from './components/login';
import Dashboard from './components/dashboard';
import CategoryReg from './components/CategoryReg';
import UserReg from './components/userReg';
import WaiterReg from './components/WaiterReg';
import Inventory from './components/Inventory';
import ProductReg from './components/ProductReg';
import ForgetPass from './components/ForgetPass';
import KOT from "./components/KOT";
import PrintBill from "./components/PrintBill";
import Kitchen from './components/Kitchen';
import SubKitchen from './components/SubKitchen';
import EditProducts from './components/EditProducts';
import AreaReg from './components/AreaReg';
import TableView from './components/TableView';
import TableReg from './components/TableReg';
import TableAreaReg from './components/TableAreaReg';
import BaseMenuReg from './components/BaseMenuReg';
import Menu from './components/Menu';
import ViewDashboard from './components/ViewDashboard';
import BillerApp from './components/BillerApp';
import AddCaptain from './components/AddCaptain';
import AddItem from './components/AddItem';
import AddonReg from './components/AddonReg';
import EditAddon from './components/EditAddon.jsx'
import Signup from './components/Signup';
import AuthSign from './components/AuthSign';
import CreatePassword from './components/CreatePassword';
import KitchenDisplaySystem from './components/KitchenDisplaySystem';
import "@fontsource/nunito"; // Defaults to weight 400
import "@fontsource/nunito/400.css"; // Specify weight
import "@fontsource/nunito/400-italic.css"; // Specify weight and style
import ProtectedRoute from './components/ProtectedRoute';
import CaptainReg from './components/CaptainReg';
import AddRecipe from './components/AddRecipe';
import CashReceipt from './components/Receipt/Receipt/CashReceipt';
import RecipeManagement from './components/RecipeManagement';
import DBProvider, { DBContext } from './components/DBContext';
import DineProvider from './components/DineContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Error404 from './components/Error404';
import SoftwareSettings from './components/SoftwareSettings';
import EditItem from './components/EditItem';
import AddTax from './components/AddTax';
import Discount from './components/Discount';
import EditTax from './components/EditTax';
import BillReport from './components/BillReport';
import LedgerReg from './components/Master/AccountRegistration/LedgerRegistration/LedgerReg';
import LedgerRegMob from './components/Master/AccountRegistration/LedgerRegistration/LedgerRegMob';
import { Emitter } from '@socket.io/component-emitter';
import FoodMenu from './components/QRScanner/FoodMenu.jsx';
import PrintDesignDefault from './components/InvoiceDesigner/PrintDesignDefault.jsx';
import BillDesigner from './components/InvoiceDesigner/BillDesigner.jsx';
import FoodMenuScanner from './components/FoodScanner.jsx';
import Report from './components/Report';
import EventViewer from './components/EventViewer';
import CustomerDetails from './components/CustomerDetails';
import ItemSalesReport from './components/ItemSalesReport';
import GSTReport from './components/GSTReport';
import StaffPerformance from './components/StaffPerformance';
import ItemReports from './components/ItemReports';

function App() {
    useEffect(() => {
        // Store the original emit function
        const originalEmit = Emitter.prototype.emit;

        // Create a safe version that handles corrupted callbacks
        Emitter.prototype.emit = function (event) {
            this._callbacks = this._callbacks || {};

            var args = new Array(arguments.length - 1);
            var callbacks = this._callbacks['$' + event];

            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }

            if (callbacks) {
                // Filter out any non-function callbacks to prevent the error
                callbacks = callbacks.filter(cb => typeof cb === 'function');

                if (callbacks.length === 0) {
                    // Remove empty callback arrays to prevent memory leaks
                    delete this._callbacks['$' + event];
                    return this;
                }

                // Update the stored callbacks with only valid functions
                this._callbacks['$' + event] = callbacks;

                callbacks = callbacks.slice(0);
                for (var i = 0, len = callbacks.length; i < len; ++i) {
                    try {
                        callbacks[i].apply(this, args);
                    } catch (error) {
                        console.error('Emitter callback error:', error);
                    }
                }
            }

            return this;
        };

        return () => {
            // Restore original emit when component unmounts
            Emitter.prototype.emit = originalEmit;
        };
    }, []);

    return (
        <Router>
            <DBProvider>
                <DineProvider>
                    <AppRoutes />
                    <ToastContainer
                        position="top-right"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </DineProvider>
            </DBProvider>
        </Router>
    );
}

function AppRoutes() {
    const { logginedDB, user } = useContext(DBContext);

    const location = useLocation();

    useEffect(() => {
        const redirect = localStorage.getItem('redirect');
        if (location.pathname !== '/signup' && redirect) {
            localStorage.removeItem('redirect');
        }
    }, [location.pathname]);

    return (
        <Routes>
            <Route path="/" element={user ? <ViewDashboard /> : !user && <Login />} />
            <Route path="/ViewDashboard" element={<ProtectedRoute permission="viewDashboard"><ViewDashboard /></ProtectedRoute>} />
            <Route path="/CategoryReg" element={<ProtectedRoute permission="manageMasters"><CategoryReg /></ProtectedRoute>} />
            <Route path="/UserReg" element={<ProtectedRoute permission="manageMasters"><UserReg /></ProtectedRoute>} />
            <Route path="/WaiterReg" element={<ProtectedRoute permission="manageMasters"><WaiterReg /></ProtectedRoute>} />
            <Route path="/BillReport" element={<ProtectedRoute permission="viewReports"><BillReport /></ProtectedRoute>} />
            <Route path="/KOT" element={<ProtectedRoute><KOT /></ProtectedRoute>} />
            <Route path="/PrintBill" element={<ProtectedRoute><PrintBill /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/inventory/:page" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/Inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/Inventory/:page" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/productreg" element={<ProtectedRoute permission="manageMasters"><ProductReg /></ProtectedRoute>} />
            <Route path="/forgetpass" element={<ForgetPass />} />
            <Route path="/Kitchen" element={<ProtectedRoute><Kitchen /></ProtectedRoute>} />
            <Route path="/SubKitchen" element={<ProtectedRoute><SubKitchen /></ProtectedRoute>} />
            <Route path="/EditProducts" element={<ProtectedRoute permission="manageMasters"><EditProducts /></ProtectedRoute>} />
            <Route path="/AreaReg" element={<ProtectedRoute permission="manageMasters"><AreaReg /></ProtectedRoute>} />
            <Route path="/TableView" element={<ProtectedRoute><TableView /></ProtectedRoute>} />
            <Route path="/TableReg" element={<ProtectedRoute permission="manageMasters"><TableReg /></ProtectedRoute>} />
            <Route path="/TableAreaReg" element={<ProtectedRoute permission="manageMasters"><TableAreaReg /></ProtectedRoute>} />
            <Route path="/BaseMenuReg" element={<ProtectedRoute permission="manageMasters"><BaseMenuReg /></ProtectedRoute>} />
            <Route path="/Menu" element={<ProtectedRoute permission="manageMasters"><Menu /></ProtectedRoute>} />
            <Route path="/BillerApp" element={<ProtectedRoute permission="manageSettings"><BillerApp /></ProtectedRoute>} />
            <Route path="/AddCaptain" element={<ProtectedRoute permission="manageMasters"><AddCaptain /></ProtectedRoute>} />
            <Route path="/AddItem" element={<ProtectedRoute permission="manageMasters"><AddItem /></ProtectedRoute>} />
            <Route path="/AddonReg" element={<ProtectedRoute permission="manageMasters"><AddonReg /></ProtectedRoute>} />
            <Route path="/CaptainReg" element={<ProtectedRoute permission="manageMasters"><CaptainReg /></ProtectedRoute>} />
            <Route path="/Error" element={<ProtectedRoute><Error404 /></ProtectedRoute>} />
            <Route path="*" element={<ProtectedRoute><Error404 /></ProtectedRoute>} />
            <Route path="/KitchenDisplaySystem" element={<ProtectedRoute><KitchenDisplaySystem /></ProtectedRoute>} />
            <Route path='/EditAddon' element={<ProtectedRoute permission="manageMasters">< EditAddon /></ProtectedRoute>} />
            <Route path="/AddRecipe" element={<ProtectedRoute permission="manageMasters"><AddRecipe /></ProtectedRoute>} />
            <Route path="/RecipeManagement" element={<ProtectedRoute permission="manageMasters"><RecipeManagement /></ProtectedRoute>} />
            <Route path='/Signup' element={< Signup />} />
            <Route path='/AuthSign' element={< AuthSign />} />
            <Route path='/CreatePassword' element={< CreatePassword />} />
            <Route path='/CashReceipt' element={< CashReceipt />} />
            <Route path='/SoftwareSettings' element={<ProtectedRoute permission="manageSettings"><SoftwareSettings /></ProtectedRoute>} />
            <Route path='/EditItem' element={<ProtectedRoute permission="manageMasters"><EditItem /></ProtectedRoute>} />
            <Route path='/AddTax' element={<ProtectedRoute permission="manageMasters"><AddTax /></ProtectedRoute>} />
            <Route path='/EditTax' element={<ProtectedRoute permission="manageMasters"><EditTax /></ProtectedRoute>} />
            <Route path='/Discount' element={<ProtectedRoute permission="manageMasters"><Discount /></ProtectedRoute>} />
            <Route path="/ledger" element={<ProtectedRoute permission="manageMasters"><LedgerReg /></ProtectedRoute>} />
            <Route path="/ledmob" element={<ProtectedRoute permission="manageMasters"><LedgerRegMob /></ProtectedRoute>} />
            <Route path="/FoodMenu" element={<FoodMenu />} />
            <Route path="/PrintDesignDefault" element={<ProtectedRoute permission="manageSettings"><PrintDesignDefault /></ProtectedRoute>} />
            <Route path="/BillDesigner" element={<ProtectedRoute permission="manageSettings"><BillDesigner /></ProtectedRoute>} />
            <Route path="/FoodMenuScanner" element={<ProtectedRoute><FoodMenuScanner /></ProtectedRoute>} />
            <Route path="/Report" element={<ProtectedRoute permission="viewReports"><Report /></ProtectedRoute>} />
            <Route path="/EventViewer" element={<ProtectedRoute permission="viewAuditLogs">{(localStorage.getItem('userName') === 'shersoft' || localStorage.getItem('USER') === 'shersoft') ? <EventViewer /> : <Navigate to="/TableView" replace />}</ProtectedRoute>} />
            <Route path="/CustomerDetails" element={<ProtectedRoute permission="viewReports"><CustomerDetails /></ProtectedRoute>} />
            <Route path="/ItemSalesReport" element={<ProtectedRoute permission="viewReports"><ItemSalesReport /></ProtectedRoute>} />
            <Route path="/ItemReports" element={<ProtectedRoute permission="viewReports"><ItemReports /></ProtectedRoute>} />
            <Route path="/GSTReport" element={<ProtectedRoute permission="viewReports"><GSTReport /></ProtectedRoute>} />
            <Route path="/StaffPerformance" element={<ProtectedRoute permission="viewReports"><StaffPerformance /></ProtectedRoute>} />
        </Routes>
    );
}

export default App;
